import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CURRENT_ENVIROMENT, SERVICE_END_POINT } from '../../../shared';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

const httpOptions = {
headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
providedIn: 'root'
})
export class AnnuitantDetailService {

	QuoteDataCapture = {
		'quoteRefNo': '',
		'formSessionId': '',
		'channelType': '',
		'source': '',
		'isEditMode': '',
		'userProductRole': '',
		'searchQuoteType': '',
		'userProductCommencementRole': '',
		'product': '',
		'productCodeModels': [],
		'dealPartnerProductModel': {
			'dealpartnerCode': '',
			'product': 'C',
			'productCodeModels': []
		},
		'customer': {
			'consentIndicator': '',
			'consentDate': '',
			'womConsent': '',
			'womConsentDate': '',
			'title': '',
			'surname': '',
			'forename': '',
			'middleName': '',
			'dateOfBirth': '',
			'ukaddressIndicator': '',
			'emailAddress': '',
			'contactNumber': '',
			'address': {
				'countryCode': '',
				'postcode': '',
				'line1': '',
				'line2': '',
				'line3': '',
				'line4': ''
			},
			'gender': '',
			'maritalStatus': '',
			'bankruptInd': '',
			'careProviderName': '',
			'isEditMode': ''
		},
		'broker': null,
		'fundModel': [],
		'quoteBasis': {
			'cedingPolicyNos': '',
			'policyTerm': null,
			'fundingType': '',
			'policyTermMonths': null,
			'quoteType': '',
			'commencementDate': '',
			'selectedRetirementDate': '',
			'currentRate': '',
			'quoteRateDate': '',
			'productCode': '',
			'dealPartnerPolicyStrtDt': '',
			'paymentFrequency': '',
			'paymentAdvance': '',
			'earlyRetirement': '',
			'guaranteedAnnuityRate': '',
			'profitAdjustmentInd': '',
			'profitAdjustmentPercentage': '',
			'rateGuaranteeQuoteInd': ''
		},
		'benefitBasis': {
			'pensionFund': '',
			'annualIncome': '',
			'maturityAmount': '',
			'taxFreeCashAmountPercent': '',
			'taxFreeCashAmount': '',
			'taxFreeCashPercentage': '',
			'netPensionFund': '',
			'post88AnnualIncome': '',
			'pre88AnnualIncome': '',
			'garIndicator': '',
			'guaranteeAmt': '',
			'dateEligibleFrGuarantee': '',
			'cedingFundAmount': '',
			'externalFundAmount': '',
			'proportionIndicator': '',
			'escalationType': '',
			'escalationRate': '',
			'secondLifePensionPercentageType': '',
			'secondLifePensionPercentage': null,
			'secondLifeAnyOrNamed': '',
			'overlapType': '',
			'guaranteedTermIndicator': '',
			'pre88EscalationType': null,
			'post88EscalationType': null,
			'pre88SecondLifePensionPercentageType': '',
			'post88SecondLifePensionPercentageType': '',
			'benefitType': '',
			'minAgeForGarYears': '',
			'minAgeForGarMonths': '',
			'maxAgeForGarYears': '',
			'maxAgeForGarMonths': '',
			'vpPercentageType': '',
			'vpPercentage': '',
			'vpBasis': '',
			'totalFund': '',
			'monthlyIncome': '',
			'careProviderFee': ''
		},
		'secondLife': {},
		'underwriting': {
			'underwritingLife': '',
			'netAmount': '',
			'annUnderwritingDecision': '',
			'depUnderwritingDecision': '',
			'uwDecision': '',
			'uwDecisionExpiry': null,
			'uwDirtyData': '',
			'lifeExpectancy': '',
			'vectorCode': ''
		},
		'currentScreen': 'Customer'
	};

	private endPoints = SERVICE_END_POINT[CURRENT_ENVIROMENT.environment];

	constructor(private http: HttpClient,private router: Router) { }

	postAnnuitantDetail(customer: any){
		
		this.QuoteDataCapture.customer.dateOfBirth = customer.dateOfBirth;
		this.QuoteDataCapture.customer.gender = customer.gender;
		this.QuoteDataCapture.customer.maritalStatus = customer.maritalStatus;
		this.QuoteDataCapture.customer.ukaddressIndicator = customer.ukaddressIndicator;
		this.QuoteDataCapture.customer.address.postcode = customer.postcode;
		if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
			this.http.get<any>(this.endPoints.saveQuoteDataCapture).subscribe(
				res=>{
				//console.log(res);
				this.router.navigate(['/home/your-pension-savings']);
				
			},
			error=>this.router.navigate(['/home/your-pension-savings'])
			);
		} else {
			//console.log(this.endPoints.saveQuoteDataCapture);
			return this.http.post<any>(this.endPoints.saveQuoteDataCapture, this.QuoteDataCapture, httpOptions)
					.subscribe(
								res=>{
									//console.log(res);
									this.router.navigate(['/home/your-pension-savings']);
								},
								error=>{
									//console.log(error)
								}	
							   );
		}
	}

	getOtherTitle(): Observable<any> {
		const accessURL = this.endPoints['getOtherTitleList'];
		//console.log(accessURL);
		//console.log(this.http.get(accessURL));
		// this.http.get(accessURL).subscribe(res=>
		// {
		// 	//console.log('result', JSON.stringify(res));
		// 	//console.log('3');
		// 	result = res;
		// });	
		// return result;	
		return this.http.get(accessURL);
	  }
	  
}
